// styled-components based extension
import React from 'react'
import styled from 'styled-components'
import { themeGet } from 'styled-system'
import { Button, Text } from '@magicsoup.io/stock'

const MissionButton = styled(Button)`
  background-color: ${themeGet('colors.primary', '#6af0d0')};
  display: flex;
  color: white;
  text-transform: uppercase;
  font-weight: 500;
  border: none;
  line-height: 18px;
  align-items: center;
`

const Addon = styled.img`
  width: 18px;
  display: inline-block;
`

const Label = styled(Text)`
  display: block;
`

MissionButton.defaultProps = {
  as: 'button',
  py: 3,
  px: 4,
  borderRadius: 6
}

Addon.defaultProps = {
  as: 'img',
  mx: 2
}

Label.defaultProps = {
  as:'span',
  px: 2
}

MissionButton.Addon = Addon
MissionButton.Label = Label

export default MissionButton